import { createFileRoute } from "@tanstack/react-router"
import { SettingsPage } from "@/features/schema-management/pages/SettingsPage"

export const Route = createFileRoute("/_authenticated/agent/document/settings")({
    component: SettingsPage,
})
